let IconButton = function (props) {
  let src = props.icon.indexOf(".") === 0 ? props.icon : ("./img/mc/icon." + props.icon + ".svg");
  let scale = props.scale || 1;
  let width = 20;
  let height = 20;
  let weight = props.weight || "normal";
  let display = props.display || "tooltip";
  let tooltip = display === "tooltip" ? props.label : null;
  let text = display === "text" ? <span>{props.label}</span> : null;

  return (
    <button
      className="mc-icon-button"
      id={props.id}
      data-tooltip={tooltip}
      data-display={display}
      data-weight={weight}
      aria-label={props.label}
      disabled={!!props.disabled}
      aria-pressed={[true, false].includes(props.pressed) ? !!props.pressed : null}
      onClick={props.onPress}>
        <img src={src} width={width * scale} height={height * scale}/>
        {text}
    </button>
  );
};

module.exports = IconButton;
